import { getApiDomain } from "src/utils/apiHelpers";
import baseFetch from "../baseFetch";
import { HOME_API_ENDPOINTS, REQUEST_METHODS } from "constants/network";

export const getUserDetails = async () => {
  return baseFetch({
    url: HOME_API_ENDPOINTS.ACCOUNT_DETAILS,
    method: REQUEST_METHODS.GET,
    headers: {
      caller: getApiDomain(),
    },
  });
};
